export type PreviewSwatchSelectOption = {
	value?: unknown;
	label?: string;
	previewSwatches?: string[];
};

export function normalizePreviewSwatches(
	option: PreviewSwatchSelectOption | null | undefined
): string[] {
	if (!option?.previewSwatches?.length) {
		return [];
	}
	return option.previewSwatches
		.filter((swatch): swatch is string => !!swatch && !!swatch.trim())
		.slice(0, 4);
}

export function resolveTriggerPreviewSwatches(params: {
	multiple: boolean;
	selectedOption: PreviewSwatchSelectOption | null;
	allOptions: PreviewSwatchSelectOption[];
	value: unknown;
}): string[] {
	if (params.multiple) {
		return [];
	}

	const selectedSwatches = normalizePreviewSwatches(params.selectedOption);
	if (selectedSwatches.length > 0) {
		return selectedSwatches;
	}

	const normalizedValue =
		typeof params.value === 'string'
			? params.value.trim().toLowerCase()
			: '';
	if (normalizedValue) {
		const byValue = params.allOptions.find(candidate => {
			if (typeof candidate.value !== 'string') {
				return false;
			}
			return (
				candidate.value.trim().toLowerCase() === normalizedValue &&
				normalizePreviewSwatches(candidate).length > 0
			);
		});
		if (byValue) {
			return normalizePreviewSwatches(byValue);
		}
	}

	const fallbackLabel = (
		params.selectedOption?.label ??
		(typeof params.value === 'string' ? params.value : '')
	)
		.trim()
		.toLowerCase();
	if (!fallbackLabel) {
		return [];
	}

	const byLabel = params.allOptions.find(
		candidate =>
			(candidate.label ?? '').trim().toLowerCase() === fallbackLabel &&
			normalizePreviewSwatches(candidate).length > 0
	);
	return normalizePreviewSwatches(byLabel);
}
